module.exports = __webpack_public_path__ + "img/Prog-final-Inperson-day1exh-v1.a9ec6940.svg";